import { memo } from "react";
import { useElement, useLocale } from "../../../../hooks";
import { useGarageTotal } from "./hooks";
import { DashboardWidgetProps } from "../types";
export const GarageTotal = memo(({ data, action }: DashboardWidgetProps) => {
  const { t } = useLocale();
  const Input = useElement("Input");
  const Button = useElement("Button");
  const { applyFilters, setWidgetTitle, title, count } = useGarageTotal({
    data,
    action,
  });

  const renderFilters = () => {
    return (
      <form onSubmit={applyFilters}>
        <Input
          onChange={setWidgetTitle}
          value={title}
          placeholder={t("widgetTitle")}
        />
        <Button
          type="submit"
          className="btn btn-primary hi-check-circle"
        ></Button>
      </form>
    );
  };

  return data.configure ? (
    renderFilters()
  ) : (
    <>
      <i className="widget-icon hi-home"></i>
      {count}
    </>
  );
});
